
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Upload } from 'lucide-react';
import { useFormContext } from 'react-hook-form';

interface AdminProfileSectionProps {
  profilePreview: string;
  onProfileImageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const AdminProfileSection = ({ profilePreview, onProfileImageChange }: AdminProfileSectionProps) => {
  const form = useFormContext();

  return (
    <Card>
      <CardHeader>
        <CardTitle>Profile Image</CardTitle>
        <CardDescription>Upload a profile image for the administrator</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col items-center space-y-4">
          <Avatar className="h-32 w-32">
            <AvatarImage src={profilePreview} alt="Profile preview" />
            <AvatarFallback>
              {form.getValues('firstName')?.charAt(0) || ''}
              {form.getValues('lastName')?.charAt(0) || ''}
            </AvatarFallback>
          </Avatar>
          <div className="grid w-full max-w-sm items-center gap-1.5">
            <label 
              htmlFor="profileImage"
              className="cursor-pointer flex items-center justify-center gap-2 text-sm text-primary"
            >
              <Upload className="h-4 w-4" />
              Upload Image
            </label>
            <input
              id="profileImage"
              type="file"
              accept="image/*"
              className="hidden"
              onChange={onProfileImageChange}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default AdminProfileSection;
